import { useMemo } from 'react'
import { sanitizeHtml, looksLikeHtml } from '../utils/sanitizeHtml'
import { cn } from '../lib/shadcn/utils'
import './RichTextEditor.css'

interface EmailBodyProps {
  body: string
  className?: string
}

// Renders a stored message body. HTML bodies (WYSIWYG emails) are sanitized and
// rendered as rich text; plain-text bodies (SMS, inbound/legacy emails) keep
// their line breaks via whitespace-pre-wrap.
export default function EmailBody({ body, className }: EmailBodyProps) {
  const isHtml = useMemo(() => looksLikeHtml(body), [body])
  const clean = useMemo(() => (isHtml ? sanitizeHtml(body) : ''), [isHtml, body])

  if (isHtml) {
    return (
      <div
        className={cn('rte-content', className)}
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    )
  }

  return <p className={cn('whitespace-pre-wrap break-words', className)}>{body}</p>
}
